import {Component} from '@angular/core';
import { LayoutService } from '@app/shared/layout/layout.service';

// import * as fromLayout from '@app/core/store/layout';
// import { Store } from '@ngrx/store';

@Component({
  selector: 'sa-minify-menu',
  template: `<span class="minifyme justify-content-center align-items-center" (click)="toggle()">
    <i class="fa fa-arrow-circle-left hit"></i>
</span>`,
})
export class MinifyMenuComponent {

  constructor(
  //  private store: Store<any>,
   private layoutService: LayoutService) {
  }

  toggle() {
    this.layoutService.onMinifyMenu()
  }
}
